import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  tabs: {
    minHeight: 42,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
    height: 2,
  },
  tab: {
    minHeight: 42,
    minWidth: 0,
    padding: "9px 16px",
    opacity: 1,
    color: theme.palette.text.secondary,
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
    letterSpacing: "0.4px",
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  tabLabel: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    textTransform: "uppercase",
  },
  icon: {
    marginRight: theme.spacing(1),
    fontSize: 24,
  },
}));
